import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import ApiService from "../../../src/apiService";

export default class ModalDelete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            url: this.props.delete.url,
            key: this.props.delete.id,
            allergy: null,
        };
        
        this.delAllergy = this.delAllergy.bind(this);
    }

    delAllergy = async e => {
        let res = await ApiService.delete(this.state.url);
        if (res.code === 200) {
            if (res.code === 200) {
                setTimeout(
                    function () {
                        this.props.parentCallback(res.data);
                    }.bind(this),
                    200
                );
                this.props.onHide();
            } else {
                console.log(res.code);
            }
        }
    }

    render() {
        return (
            <Modal {...this.props} aria-labelledby="modal-alergi">
                <ModalHeader closeButton>
                    <ModalTitle id="modal-alergi">Hapus Data {this.props.delete.name}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                            Yakin untuk menghapus data {this.props.delete.explain} pasien {this.props.patient.patients.name}?
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className="row">
                        <div className="col-12">
                            <button
                                type="button"
                                onClick={this.props.onHide}
                                className="btn btn-outline-secondary"
                            >
                                Batal
                            </button>
                            <button type="button" className="btn btn-primary"
                                onClick={this.delAllergy}
                            >
                                Hapus {this.props.delete.name} Pasien
                            </button>
                        </div>
                    </div>
                </ModalFooter>
            </Modal>
        );
    }
}
